/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { AgencyBranchSummaryResponseDtoBusinessName } from './agencyBranchSummaryResponseDtoBusinessName';
import type { AgencyBranchSummaryResponseDtoCountry } from './agencyBranchSummaryResponseDtoCountry';

export interface AgencyBranchSummaryResponseDto {
  id: string;
  name: string;
  /** @nullable */
  businessName: AgencyBranchSummaryResponseDtoBusinessName;
  street: string;
  streetNumber: string;
  city: string;
  zipCode: string;
  /** @nullable */
  country: AgencyBranchSummaryResponseDtoCountry;
}
